import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const ROLES = ["CEO", "Sales", "Analyst", "Customer", "pending"];

export default function Team() {
  const [users, setUsers] = useState(null);
  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load().catch(() => setUsers([])); }, []);

  const updateRole = async (uid, role) => {
    try { await api.patch(`/users/${uid}`, { role }); toast.success("Role updated"); await load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const toggleActive = async (uid, current) => {
    try { await api.patch(`/users/${uid}`, { is_active: !current }); toast.success("Updated"); await load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  if (users === null) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 text-sky-400 animate-spin" /></div>;

  return (
    <div data-testid="team-management">
      <div className="tick-label text-sky-400 mb-2">/ Team</div>
      <h1 className="font-display font-black text-3xl text-slate-100 mb-2">Manage internal users</h1>
      <p className="text-sm text-slate-400 mb-6">New users are created when they sign in via Google. Promote pending users by changing their role.</p>

      <div className="panel">
        <div className="grid grid-cols-12 gap-3 px-4 py-2.5 border-b border-[var(--border-soft)] tick-label">
          <div className="col-span-5">User</div>
          <div className="col-span-3">Role</div>
          <div className="col-span-2 text-center">Active</div>
          <div className="col-span-2 text-right">Last login</div>
        </div>
        {users.map((u) => (
          <div key={u.user_id} className="grid grid-cols-12 gap-3 px-4 py-3 border-b border-[var(--border-soft)] last:border-0">
            <div className="col-span-5">
              <div className="text-sm text-slate-100">{u.name}</div>
              <div className="font-mono text-[10px] text-slate-500">{u.email}</div>
            </div>
            <div className="col-span-3">
              <select value={u.role} onChange={(e) => updateRole(u.user_id, e.target.value)} className="bg-[var(--bg-primary)] border border-slate-700 text-slate-100 text-xs px-2 py-1.5 font-mono" data-testid={`role-select-${u.user_id}`}>
                {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div className="col-span-2 text-center">
              <button onClick={() => toggleActive(u.user_id, u.is_active)} className={`font-mono text-[10px] tracking-widest uppercase px-2 py-1 border ${u.is_active ? "text-emerald-400 border-emerald-500/40" : "text-rose-400 border-rose-500/40"}`}>
                {u.is_active ? "Active" : "Inactive"}
              </button>
            </div>
            <div className="col-span-2 text-right font-mono text-[10px] text-slate-500">{(u.last_login_at || "").slice(0, 19).replace("T", " ")}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
